import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import Monthly from './Monthly';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { MIN_MONTHS, MAX_MONTHS } = customFrequencyUtils;

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    fontSize: 16,
    fontWeight: 500,
  },
  daySelect: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 0px',
    '& .MuiOutlinedInput-root': {
      margin: '0px 8px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 16px',
      borderRadius: '12px',
    },
    '& .MuiTextField-root': {
      width: 'auto',
    },
  },
  monthlySection: {
    padding: '24px 0px 0px',
  },
}));

const EveryXMonths = () => {
  const { dispatch, state } = useContext(FrequencyContext);
  const { classes } = useStyles();

  // @ts-expect-error FIXME TS7006
  const handleChange = (e) => {
    const interval = parseInt(e.target.value, 10);
    interval && dispatch({ type: 'UPDATE_EVERY_X_INTERVAL', payload: interval });
  };

  return (
    <Box id='every-x-months' className={classes.root}>
      <Box className={classes.daySelect}>
        <Typography className={classes.freqDescription}>Every</Typography>
        <TextField
          type='number'
          inputProps={{ min: MIN_MONTHS, max: MAX_MONTHS }}
          value={state?.interval || 2}
          onChange={handleChange}
          variant='outlined'
        />
        <Typography className={classes.freqDescription}>months</Typography>
      </Box>
      <Box>
        <div className={classes.monthlySection}>
          <Monthly />
        </div>
      </Box>
    </Box>
  );
};

export default EveryXMonths;
